
// 공통 함수
export const preDate = (selectDate, type) => {
  let result = new Date(selectDate);
  if (type == "year") {
    result.setFullYear(result.getFullYear() - 1);
  } else if (type == "month") {
    result.setMonth(result.getMonth() - 1);
  }
  return result;
};

/**
 * 월,일 등 숫자 앞에 0 붙이기
 * @param   num     앞에 0을 붙일 숫자 값
 * @param   digit   글자의 자릿수를 지정 ( 2자릿수인 경우 00, 3자릿수인 경우 000 … )
 */
export const autoLeftPad = (num, digit) => {
  if (String(num).length < digit) {
    num = new Array(digit - String(num).length + 1).join("0") + num;
  }
  return num;
};

/**
 * 양수 음수에 따른 css class name
 * @param   num  숫자
 */
export const numChkClass = (num) => {
  if (num) {
    if (Number(num) > 0) return "txt_plus";
    else if (Number(num) < 0) return "txt_minus";
    else return "txt_zero";
  }
};

/**
 * (콤마) 소수점 내림
 * @param   num     변환할 숫자
 * @param   digit   자릿수 (사용안할 때는 null)
 * @param   type    $, % 등의 기호 (선택) (사용안할 때는 null)
 * @param   sign    앞에 + , - (사용안할 때는 null)
 */
export const numSignFloor = (num, digit, type, sign = true) => {
  if (num) {
    if (digit === 0 || digit) {
      const number = Number(num);
      const factor = Math.pow(10, digit);
      const floored = Math.floor(number * factor) / factor;
      num = String(
        floored.toLocaleString("ko-KR", { maximumFractionDigits: digit })
      );
    } else {
      num = String(Number(num).toLocaleString("ko-KR"));
    }
    if (sign) {
      if (type) {
        if (String(num).charAt(0) != "-" && num != 0) return `+${num}${type}`;
        else return `${num}${type}`;
      }
      if (String(num).charAt(0) != "-" && num != 0) return `+${num}`;
      else return num;
    }else{
      return num;
    }
  } else {
    return 0;
  }
};

/**
 * yyyy-mm-ddThh:mm -> T제외
 * @param   datetime  yyyy-mm-ddThh:mm 형식의 데이터
 * @param   type => 0 날짜까지 , 1 분까지
 */
export const formatTime = (datetime, type = 1) => {
  if (datetime) {
    let date = datetime.split("T")[0];
    let time = datetime.split("T")[1].slice(0, 5);
    if (type == 1) return `${date} ${time}`;
    else return date;
  }
  return;
};

/**
 * JWT토큰의 expire 여부
 * @param   token  jwt 토큰값
 */
export function isTokenExpired(token) {
  if (!token) return true;
  try {
    const { exp } = parseJwt(token);
    if (!exp) return true;
    return Date.now() >= exp * 1000;
  } catch (error) {
    return true;
  }
}

/**
 * JWT 디코딩 페이로드 추출
 * @param   token  jwt 토큰값
 */
export function parseJwt(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(jsonPayload);
}





